<ng-container *ngVar="editing$ | async as editing">
  @if (!documents.length) {
    <div class="flex flex-col w-full gap-4 justify-center items-center py-20">
      <svg-icon [src]="'character-holding-papers'"></svg-icon>

      <div class="flex flex-col gap-2 justify-center items-center">
        <div class="text-navy-90 font-bold text-4xl">{{ buildTranslationKey('didntAddDocumentsYet') | translate }}</div>

        <div class="text-navy-70 text-base whitespace-pre-wrap text-center">
          {{ buildTranslationKey('didntAddDocumentsYetDescription') | translate }}
        </div>
      </div>

      <app-new-button
        class="add-first-doc-button"
        [svgIconPath]="'Add'"
        [size]="'responsive'"
        [type]="'primary'"
        (click)="openAddDocumentSidePanel()"
      >
        {{ buildTranslationKey('addDocumentBtnText') | translate }}
      </app-new-button>
    </div>
  }

  <div
    cdkDropListGroup
    class="documents-container pb-7.5"
    [class.published-page]="!editing"
  >
    @if (editing && documents.length) {
      <div class="document group gap-2 justify-center" (click)="openAddDocumentSidePanel()">
        <svg-icon class="w-12.5 h-12.5" [src]="'add-filled'"></svg-icon>

        <div class="text-navy-90 py-2.5 px-3 rounded-md text-base group-hover:bg-navy-40">
          {{ buildTranslationKey('addDocumentBtnText') | translate }}
        </div>
      </div>
    }

    <div
      #placeholder
      cdkDropList
      class="placeholder-drop-list"
      [cdkDropListDisabled]="!editing"
      (cdkDropListEntered)="onDropListEntered($event)"
      (cdkDropListDropped)="onDropListDropped()"
    ></div>

    @for (document of documents; track document.id) {
      <div
        cdkDropList
        [cdkDropListDisabled]="!editing"
        (cdkDropListEntered)="onDropListEntered($event)"
        (cdkDropListDropped)="onDropListDropped()"
      >
        <div
          class="trust-document-item relative"
          cdkDrag
          cdkDragBoundary=".documents-container"
          [cdkDragData]="document"
        >
          <div
            class="document font-main w-full bg-white cursor-pointer border rounded-md border-navy-50 shadow-sm px-2 pt-5 pb-2 flex flex-col justify-between items-center hover:border-navy-90"
            (click)="onDocumentClick(document)">
            <div class="flex flex-col gap-2 items-center flex-1 max-w-full">
              <svg-icon class="document-icon" [src]="'card'"></svg-icon>

              <div
                class="lines-clamp text-navy-90 text-2xl font-bold text-center max-w-full overflow-hidden overflow-ellipsis"
                [ngbTooltip]="document.name"
                [disableTooltip]="isMobile"
                [openTooltipWhenOverflowedAndHovered]="true"
                [openOnWidthOverflow]="true"
                [openOnHeightOverflow]="true"
                [placement]="'top top-start top-end'"
              >
                {{ document.name }}
              </div>
            </div>

            @if (editing) {
              <app-icon-button
                class="edit-button"
                [svgIconPath]="'edit'"
                [type]="'basic'"
                [iconSize]="'small'"
              ></app-icon-button>
            } @else {
              <app-download-or-request-access-button
                [evidences]="document.evidence_files"
                [downloadingResource]="DownloadingResource.Documents"
                [resourceId]="document.id"
              ></app-download-or-request-access-button>
            }
          </div>
          @if (editing) {
            <app-new-button
              cdkDragHandle
              class="cdk-drag-handle top-0 left-0 h-10 w-10 bg-navy-40 border border-navy-60 transform -translate-x-1/2 -translate-y-1/2"
              [svgIconPath]="'drag'"
              [isOnlyIcon]="true"
              [type]="'basic'"
              [size]="'tiny'"
            ></app-new-button>
          }
        </div>
      </div>
    }
  </div>
</ng-container>
